"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeferredBatcherController = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _DeferredBatcher = require("./DeferredBatcher");
var _util = require("@blockwell/util");
var _VariableUpdateListeners = require("./VariableUpdateListeners");
class CollectingListener {
  constructor(listener) {
    (0, _defineProperty2.default)(this, "batch", []);
    (0, _defineProperty2.default)(this, "process", () => {
      let current = this.batch;
      this.batch = [];
      this.listener(current);
    });
    (0, _defineProperty2.default)(this, "debounced", (0, _util.debounce)(this.process, 500, {
      maxWait: 2000
    }));
    (0, _defineProperty2.default)(this, "callback", data => {
      this.batch.push(data);
      this.debounced();
    });
    this.listener = listener;
  }
}
class DeferredBatcherController {
  constructor(client, listener) {
    (0, _defineProperty2.default)(this, "batchers", []);
    (0, _defineProperty2.default)(this, "subscriptions", []);
    (0, _defineProperty2.default)(this, "variableUpdates", void 0);
    this.client = client;
    this.listener = listener;
    this.variableUpdates = new _VariableUpdateListeners.VariableUpdateListeners(client);
  }
  batch(network) {
    if (!this.listener) {
      throw new Error("Controller already cleaned up, can't batch anymore.");
    }
    let batcher = new _DeferredBatcher.DeferredBatcher(network, this.client, this.listener);
    this.batchers.push(batcher);
    return batcher;
  }
  collect() {
    let waiting = [];
    let execute = [];
    for (let it of this.batchers) {
      if (it.deferred) {
        execute.push(it);
      } else {
        waiting.push(it);
      }
    }
    this.batchers = waiting;
    return execute;
  }
  execute() {
    let collected = this.collect();
    if (collected.length > 0) {
      try {
        let batches = collected.map(it => {
          let calls = it.calls();
          return {
            batcher: it,
            calls: calls.batch,
            count: calls.batch.length,
            chain: calls.chain
          };
        });
        while (batches.length > 0) {
          let chain = batches[0].chain;
          let [filtered, other] = (0, _util.partition)(batches, it => it.chain.chainId === chain.chainId);
          batches = other;
          let batch = filtered.flatMap(it => it.calls);
          this.client.multicall(chain, batch).then(res => {
            for (let it of filtered) {
              try {
                let data = it.batcher.finalize(res.splice(0, it.count));
                it.batcher.result(data);
              } catch (err) {
                it.batcher.error(err);
              }
            }
          }).catch(err => {
            for (let it of filtered) {
              it.batcher.error(err);
            }
          });
        }
      } catch (err) {}
    }
  }
  updateEvents() {}
  onLogs(network, filter, listener) {
    let collect = new CollectingListener(listener);
    this.client.onLogs(network, filter, collect.callback);
    this.subscriptions.push(collect);
  }
  off(listener) {
    this.client.off(listener);
    let index = this.subscriptions.findIndex(it => it.listener === listener);
    if (index > -1) {
      this.subscriptions[index].debounced.cancel();
      this.subscriptions.splice(index, 1);
    }
  }
  clean() {
    this.listener = undefined;
    for (let it of this.subscriptions) {
      it.debounced.cancel();
      this.client.off(it.listener);
    }
    this.variableUpdates.destroy();
  }
}
exports.DeferredBatcherController = DeferredBatcherController;
//# sourceMappingURL=DeferredBatcherController.js.map